module.exports = __webpack_public_path__ + "img/Baumarktexkursion.c3086363.jpg";